  import React from 'react';
  import ReactDOM from 'react-dom/client';
  import App from './App';
  import ErrorBoundary from './ErrorBoundary';
  import reportWebVitals from './reportWebVitals';
  import { createTheme, ThemeProvider } from '@mui/material/styles';
  import CssBaseline from '@mui/material/CssBaseline';


  // Create a theme context wrapper
  function ThemedApp() {
    const [darkMode, setDarkMode] = React.useState(
      localStorage.getItem('cj_darkMode') === 'true'
    );

    const theme = createTheme({
      palette: {
        mode: darkMode ? 'dark' : 'light',
        primary: {
          main: '#1976d2',
        },
        background: {
          default: darkMode ? '#121212' : '#f5f6fa',
          paper: darkMode ? '#1e1e1e' : '#ffffff',
        },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: 8,
              textTransform: 'none',
              fontWeight: 600,
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              },
            },
          },
        },
        MuiCard: {
          styleOverrides: {
            root: {
              transition: 'all 0.3s ease-in-out',
              '&:hover': {
                transform: 'translateY(-2px)',
              },
            },
          },
        },
        MuiChip: {
          styleOverrides: {
            root: {
              transition: 'all 0.2s ease-in-out',
            },
          },
        },
      },
    });

    const toggleDarkMode = () => {
      setDarkMode(!darkMode);
      localStorage.setItem('cj_darkMode', (!darkMode).toString());
    };

    return (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <App darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      </ThemeProvider>
    );
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <ThemedApp />
      </ErrorBoundary>
    </React.StrictMode>
  );

  reportWebVitals();
